var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'circle')?_c('div',{staticClass:"watermark-circle"},[_c('img',{attrs:{"src":require("@/../resources/images/watermark-circle.svg"),"title":_vm.watermarkTitle,"alt":_vm.watermarkTitle}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }